import { DomainsListPage } from './TenantsListPage';

export const domainsRoute = [{ path: '', element: <DomainsListPage /> }];
